import Table, { Props as TableProps } from './components/Table' 
import './Table.scss'

export type { TableProps }
export { default as NetworkPaginatedTable } from './components/NetworkPaginatedTable'
export { default as LocalPaginatedTable } from './components/LocalPaginatedTable'
export default Table